import React, { useState } from 'react'
import { GrClose } from "react-icons/gr";
import Productinfo from './Productinfo';

export default function Card({ cata }) {
    

    const [info, setInfo] = useState(<div></div>)
    const [close, setClose] = useState(<div></div>)

    function CLOSE() {
        setClose(
            <div className='md:right-14 fixed md:top-10 top-4 right-4 z-50'>
                <button onClick={() => { setInfo(<div></div>); setClose(<div></div>) }}>
                    <GrClose className='w-10 h-10  mx-auto p-1 rounded-full bg-red-300' />
                </button>
            </div>
        )
    }


    return (
        <div className='p-5 border-t-2 '>{info}
            <div className='flex flex-col md:flex-row flex-wrap'>
                {cata.map((item) => {
                    return (
                        <div  className="border-2  h-fit my-4 w-full lg:w-1/3 mx-auto max-w-xs border-shasham hover:border-yakam bg-dwam shadow-xl rounded-lg ">



                            <div className="px-4 py-2">
                                <h1 className="text-3xl text-center font-bold text-yakam uppercase drop-shadow-lg">{item.Ptitle}</h1>
                            </div>

                            <div  className='bg-gradient-to-r from-seyam via-penjam to-seyam ' >
                                <img className="p-3 drop-shadow-2xl backdrop-blur-3xl bg-opacity-50 object-contain w-full h-48 " src={item.Pimg} alt={item.Pimg} />
                                
                            </div>

                            <div className="flex items-center justify-between px-4 py-2 w-full backdrop-blur-xl rounded-b-md bg-opacity-70 bg-chwaram">
                                <h1 className=" text-2xl font-bold text-shasham">{item.price}$</h1>
                                <button onClick={() => { setInfo(<Productinfo cata={item}/>); CLOSE() }} className="px-2 py-1 text-sm flex items-center font-medium text-yakam uppercase transition-colors duration-200 transform backdrop-blur-xl  bg-opacity-60 bg-white rounded hover:bg-penjam focus:bg-penjam focus:outline-none">
                                    زانیاری زیاتر
                                </button>

                            </div>

                        </div>

                    )
                })}
            </div>
            {close}
        </div>
    )
}

